import { ORDER_ID_HELPER } from './constants';
import {
  Container,
  FieldLabel,
  FieldWrapper,
  HelperText,
  OrderIdField,
  OrderIdRow,
  RecordedSlot,
  TextFieldStyled,
  WideField,
  UpdateOrderButton,
} from './styled';
import UpdateOrderIdDialog from './UpdateOrderIdDialog';
import { ConnectReportProps } from '../types';
import useController from './useController';
import { DefaultToolbarStyled } from '@/styles/overrides';

const FormContent = (props: ConnectReportProps) => {
  const { connectOrderReport, handleCloseModal, handleOpenModal, handleUpdateOrderId, showUpdateModal } =
    useController(props);
  const ErrorColumn = props.recorded ? FieldWrapper : WideField;

  return (
    <>
      <Container>
        <FieldWrapper>
          <FieldLabel>Report ID</FieldLabel>
          <TextFieldStyled disabled size="small" value={connectOrderReport?.id ?? ''} />
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Status</FieldLabel>
          <TextFieldStyled disabled size="small" value={connectOrderReport?.status ?? ''} />
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Connect Order ID</FieldLabel>
          <OrderIdRow>
            <OrderIdField>
              <TextFieldStyled disabled size="small" value={connectOrderReport?.connect_order_id ?? ''} />
              <HelperText>{ORDER_ID_HELPER}</HelperText>
            </OrderIdField>
            <UpdateOrderButton variant="outlined" onClick={handleOpenModal}>
              Update Order ID
            </UpdateOrderButton>
          </OrderIdRow>
        </FieldWrapper>

        <FieldWrapper>
          <FieldLabel>Reference ID</FieldLabel>
          <TextFieldStyled disabled size="small" value={connectOrderReport?.reference_id ?? ''} />
        </FieldWrapper>

        <ErrorColumn>
          <FieldLabel>Error description</FieldLabel>
          <TextFieldStyled
            disabled
            size="small"
            value={connectOrderReport?.error_description ?? ''}
            inputProps={{ 'aria-label': 'Error description' }}
          />
        </ErrorColumn>
        {props.recorded ? <RecordedSlot>{props.recorded}</RecordedSlot> : null}
      </Container>

      {props.embedded ? null : <DefaultToolbarStyled onClose={props.onClose} renderSaveButton={false} />}

      <UpdateOrderIdDialog
        currentConnectOrderId={connectOrderReport?.connect_order_id}
        open={showUpdateModal}
        onClose={handleCloseModal}
        onSubmit={handleUpdateOrderId}
      />
    </>
  );
};

export default FormContent;
